import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GoogleMapComponentDef } from '@df/module-google-maps/google-map/google-map.component.def';
declare module '@df/module-google-maps/google-map/google-map.component.def' {
    interface IMarkerOptions {
        storeId?: number;
    }
}
@Component({
    selector: 'google-map',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    template: ''
})
export class GoogleMapComponent extends GoogleMapComponentDef {}
